export interface ReportManagementsArray {
  id: number;
  date: string;
  employeeCode: number;
  employeeName: string;
  projectId: number;
  projectNumber: string;
  projectName: string;
  manHoursCategory: 'A' | 'B' | 'C' | 'D' | 'E' | '';
  startTime: string;
  endTime: string;
  manHoursTotal: number;
}

export type ReportManagementsGetResponse = {
  items: ReportManagementsArray[];
  page: number;
  totalPages: number;
};

export const EmptyReportManagementsGetResponse: ReportManagementsGetResponse = {
  items: [
    {
      id: 0,
      date: '',
      employeeCode: 0,
      employeeName: '',
      projectId: 0,
      projectNumber: '',
      projectName: '',
      manHoursCategory: '',
      startTime: '',
      endTime: '',
      manHoursTotal: 0,
    },
  ],
  page: 1,
  totalPages: 0,
};
